import { ActionIcon, Tooltip } from '@mantine/core';
import type { MouseEventHandler, ReactElement } from 'react';

export const DisableableIconButtonWithTooltip = ({
    disabled,
    tooltipText,
    disabledTooltipText,
    icon,
    onClick,
    onAuxClick,
}: {
    disabled: boolean;
    tooltipText?: string;
    disabledTooltipText?: string;
    icon: ReactElement;
    onClick?: () => void;
    onAuxClick?: MouseEventHandler<HTMLButtonElement>;
}) => {
    const button = (
        <ActionIcon
            disabled={disabled}
            size={'sm'}
            onClick={onClick}
            onAuxClick={onAuxClick}
            style={{ padding: '6px', backgroundColor: 'inherit' }}
            variant={'transparent'}
            color={'var(--mantine-color-base-button)'}
        >
            {icon}
        </ActionIcon>
    );

    if (disabled) {
        if (disabledTooltipText) {
            return <Tooltip label={disabledTooltipText}>{button}</Tooltip>;
        }
        return button;
    } else {
        if (tooltipText) {
            return <Tooltip label={tooltipText}>{button}</Tooltip>;
        }
        return button;
    }
};
